/**
 * @file widgetUi.ts
 * @brief Shared bits of the desktop widget: its fixed dark palette and the
 *        command sender.
 *
 * @details
 * The widget is always the dark pill, in both themes: it floats over other
 * apps (Zoom, Teams), not over our page.
 *
 * @author DES
 * @date 02-10-2026
 */

import { desktopShell, type DesktopCommand } from "@/shared/desktop/desktopShell";

export const W = {
  // The phone's warm dark ladder (DES 20-10-2026; was Apple's #1c1c1e /
  // #2c2c2e / #3a3a3c): surface = bg #232221, field = card #2A2928, chip =
  // quaternaryDark #3A3938, chip hover = bgPill #3E3D3C, muted = #A3A3A3.
  // 80% see-through over the app behind (DES 13-10-2026, trial).
  surface: "bg-[#232221]/80 text-[#f2f2f2]",
  chip: "bg-[#3A3938] text-[#f2f2f2] hover:bg-[#3E3D3C]",
  chipOn: "bg-[#5f5e5a] text-[#f2f2f2]",
  muted: "text-[#A3A3A3]",
  field: "bg-[#2A2928]",
};

export function send(cmd: DesktopCommand): void {
  desktopShell()?.sendCommand?.(cmd);
}
